import axios from "axios";
import axiosMiddleware from "redux-axios-middleware";

const config = {
  baseURL: "/api",
  responseType: "json",
  withCredentials: true, // Ensure cookies are sent with requests
};

export const axiosClient = axios.create(config);

// second client because of `interceptors` below
const axiosMiddlewareClient = axios.create(config);

const middlewareConfig = {
  interceptors: {
    request: [
      function ({ dispatch, getSourceAction }, req) {
        const sourceAction = getSourceAction(req);
        dispatch({ type: `${sourceAction.type}_REQUEST` });
        return req;
      },
    ],
  },
};

export const appAxiosMiddleware = axiosMiddleware(
  axiosMiddlewareClient,
  middlewareConfig,
);
